var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLasso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Lasso"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.72505 9.02505L4.92505 6.22505V8.85005H3.05005V3.05005H8.85005V4.92505H6.22505L9.05005 7.75005L7.72505 9.02505Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8499 12.825L21.7249 13.025C21.6332 13.775 21.4686 14.5021 21.2311 15.2063C20.9936 15.9104 20.6749 16.5833 20.2749 17.225L18.6749 16.225C19.0082 15.7167 19.2665 15.175 19.4499 14.6C19.6332 14.025 19.7665 13.4333 19.8499 12.825ZM18.8999 5.12501C19.4415 5.64168 19.9082 6.21251 20.2999 6.83751C20.6915 7.46251 21.0082 8.12501 21.2499 8.82501L19.4499 9.45001C19.2499 8.88335 18.9978 8.34376 18.6936 7.83126C18.3894 7.31876 18.0249 6.85001 17.5999 6.42501L18.8999 5.12501ZM16.2499 18.65L17.2499 20.25C16.6082 20.65 15.9353 20.9688 15.2311 21.2063C14.5269 21.4438 13.7999 21.6083 13.0499 21.7L12.8499 19.825C13.4582 19.7417 14.0499 19.6083 14.6249 19.425C15.1999 19.2417 15.7415 18.9833 16.2499 18.65ZM12.0249 2.25001C12.5915 2.25001 13.1561 2.29376 13.7186 2.38126C14.2811 2.46876 14.8249 2.61668 15.3499 2.82501L14.7249 4.60001C14.2832 4.45001 13.8394 4.33335 13.3936 4.25001C12.9478 4.16668 12.4915 4.12501 12.0249 4.12501V2.25001ZM6.44985 17.575C6.87485 18 7.3436 18.3646 7.8561 18.6688C8.3686 18.9729 8.90819 19.225 9.47485 19.425L8.84985 21.225C8.14985 20.9833 7.48735 20.6667 6.86235 20.275C6.23735 19.8833 5.66652 19.4167 5.14985 18.875L6.44985 17.575ZM4.14985 12C4.14985 12.4667 4.19152 12.9229 4.27485 13.3688C4.35819 13.8146 4.47485 14.2583 4.62485 14.7L2.84985 15.325C2.64152 14.8 2.4936 14.2563 2.4061 13.6938C2.3186 13.1313 2.27485 12.5667 2.27485 12H4.14985Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLasso);
export default __webpack_public_path__ + "static/media/icon-lasso.2ef166f9f1a8e8f7fcff576385b9e5f9.svg";
export { ForwardRef as ReactComponent };